import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsSlashCircle } from 'react-icons/bs';

import BlockReasonBadge from '#customColumnsFeature/components/BlockReasonBadge/BlockReasonBadge';
import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';
import Table from '#globalComponents/Table/Table';

import { usePostMailingBlockedRecipients } from '../../../models/campaigns/queries';

const BLOCKED_RECIPIENT_COLUMNS = [
	{
		key: 'recipientName',
		label: 'Empfänger',
		render: (r) => <span className="text-text">{r.recipientName || '-'}</span>,
	},
	{
		key: 'companyName',
		label: 'Firma',
		render: (r) => <span className="text-bgBase-800">{r.companyName || '-'}</span>,
	},
	{
		key: 'status',
		label: 'Status',
		render: (r) => <BlockReasonBadge reason={r.reason} missingKeys={r.missingKeys} />,
	},
];

const PostMailingBlockedRecipientsHint = ({ campaignId, blockedCount }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { data, isLoading } = usePostMailingBlockedRecipients(campaignId, { enabled: isOpen });

	if (!blockedCount) return null;

	return (
		<>
			<p className="flex items-center gap-1.5 text-sm text-bgBase-800">
				<BsSlashCircle className="h-4 w-4" />
				{blockedCount.toLocaleString('de-DE')} Empfänger blockiert –
				<button
					type="button"
					onClick={() => setIsOpen(true)}
					className="text-primary-600 underline hover:text-primary-700"
				>
					anzeigen
				</button>
			</p>
			<Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="l">
				<Panel.Header onClose={() => setIsOpen(false)}>Blockierte Empfänger</Panel.Header>
				<Panel.Body>
					<Table
						rows={data?.blockedRecipients ?? []}
						columns={BLOCKED_RECIPIENT_COLUMNS}
						rowId={(r) => r.crmContactId || r.crmCompanyId || r.recipientName}
						isLoading={isLoading}
						emptyLabel="Empfänger, die auf der Blacklist stehen oder denen ein Spaltenwert fehlt, erscheinen hier."
					/>
				</Panel.Body>
			</Modal>
		</>
	);
};

PostMailingBlockedRecipientsHint.propTypes = {
	campaignId: PropTypes.string.isRequired,
	blockedCount: PropTypes.number,
};

export default PostMailingBlockedRecipientsHint;
